import { lazy, Suspense } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent } from "@/components/ui/card";

const HomeThemes = lazy(() => import("@/components/HomeThemes"));

const HomeThemesSkeleton = () => (
  <section className="py-20 px-4 bg-gradient-subtle">
    <div className="container mx-auto">
      <div className="text-center mb-12">
        <Skeleton className="h-10 w-80 mx-auto mb-4" />
        <Skeleton className="h-6 w-96 mx-auto" />
      </div>
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-12">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="overflow-hidden">
            <Skeleton className="h-64 w-full" />
            <CardContent className="p-6">
              <Skeleton className="h-6 w-32 mb-2" />
              <Skeleton className="h-4 w-full" />
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="text-center">
        <Skeleton className="h-10 w-40 mx-auto" />
      </div>
    </div>
  </section>
);

const LazyHomeThemes = () => {
  return (
    <Suspense fallback={<HomeThemesSkeleton />}>
      <HomeThemes />
    </Suspense>
  );
};

export default LazyHomeThemes;